import White from "../assets/frames/White.png";
import Blue from "../assets/frames/Blue.png";
import Black from "../assets/frames/Black.png";
import Red from "../assets/frames/Red.png";
import Green from "../assets/frames/Green.png";
import Gold from "../assets/frames/Gold.png";
import DualGold from "../assets/frames/DualGold.png";
import Artifact from "../assets/frames/Artifact.png";
import DualLand from "../assets/frames/DualLand.png";
import WhiteLand from "../assets/frames/WhiteLand.png";
import BlueLand from "../assets/frames/BlueLand.png";
import BlackLand from "../assets/frames/BlackLand.png";
import RedLand from "../assets/frames/RedLand.png";
import GreenLand from "../assets/frames/GreenLand.png";
import ColourlessLand from "../assets/frames/ColourlessLand.png";
import GoldLand from "../assets/frames/GoldLand.png";

const colourPannels = {
	W: White,
	U: Blue,
	B: Black,
	R: Red,
	G: Green,
	M: Gold,
};

const gradientColours = {
	"{W}": "#fff",
	"{U}": "#0675bd",
	"{B}": "#000",
	"{R}": "#f03222",
	"{G}": "#017b42",
};

const colouredLands = {
	"{W}": WhiteLand,
	"{U}": BlueLand,
	"{B}": BlackLand,
	"{R}": RedLand,
	"{G}": GreenLand,
	"{C}": ColourlessLand,
};

export default {
	Artifact,
	gradientColours,
	colouredLands,
	colourPannels,
	DualGold,
	DualLand,
	GoldLand
};
